// cart-to-pifyform.js
// Sends cart data to Pify via postMessage (Pify listens in Custom JS)

(function () {
  const TAG = '[Cart→Pify]';

  // Only run on quote page
  if (!location.pathname.toLowerCase().includes('/pages/get-a-quote')) return;

  // ✅ NEW (only addition): helper to safely get a thumbnail URL
  function getThumbUrl(item) {
    let url =
      (item && item.image) ||
      (item && item.featured_image && item.featured_image.url) ||
      (item && item.featured_image) ||
      "";

    url = url ? String(url) : "";
    if (!url) return "";

    if (url.startsWith("//")) url = "https:" + url;

    // Try to request a smaller size from Shopify CDN when possible
    try {
      const parts = url.split("?");
      const base = parts[0];
      const qs = parts[1] ? "?" + parts[1] : "";

      if (/\.(png|jpe?g|webp|gif)$/i.test(base)) {
        const sized = base.replace(/\.(png|jpe?g|webp|gif)$/i, "_120x120_crop_center.$1");
        return sized + qs;
      }
    } catch (e) {}

    return url;
  }

  async function buildCart() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await res.json();

      // ===============================
      // EMPTY CART STATE
      // ===============================
      if (!cart.items || !cart.items.length) {
        const url = "https://summitrxusa.com/collections/all";

        const emptyHtml = `
          <div style="
            border:1px dashed #b7d4f0;
            border-radius:12px;
            padding:18px;
            background:#f8fbff;
          ">
            <div style="
              font-size:16px;
              font-weight:700;
              color:#25449c;
              margin-bottom:6px;
            ">
              Your cart is currently empty. Looking for any formulas in stock?
            </div>

            <div style="
              font-size:14px;
              color:#555;
              margin-bottom:14px;
              line-height:1.5;
            ">
              Add stock products to your cart, then return here to request a quote.
            </div>

            <a href="${url}"
               target="_top"
               onclick="try{window.top.location.href='${url}';}catch(e){} return false;"
               style="
                 display:inline-block;
                 background:#9ccc3c;
                 color:#0f2a44;
                 padding:10px 18px;
                 border-radius:8px;
                 font-weight:700;
                 font-size:14px;
                 text-decoration:none;
               ">
              Explore Our Stock Products →
            </a>

            <div style="
              margin-top:10px;
              font-size:12px;
              color:#777;
            ">
              Note: After adding items in cart, this page will list the products here.<br> 
              <br>[If you need a custom formula instead of our stock, please fill the supplements/ingredient facts and tell us more about your project below.]
            </div>
          </div>
        `;

        return {
          text: 'No items were added to the cart',
          html: emptyHtml
        };
      }

      // ===============================
      // CART WITH PRODUCTS
      // ===============================
      const count = cart.items.length;

      const text = cart.items
      .map((item, i) => {
        const v = item.variant_title ? ` (${item.variant_title})` : '';
        // one product per line (Windows-friendly newline)
        return `${i + 1}. ${item.product_title}${v}`;
      })
      .join('\r\n');


      // ✅ UPDATED (only change here): add image left, keep your text/styles intact
      const itemsHtml = cart.items.map(item => {
        const v = item.variant_title ? ` (${item.variant_title})` : '';
        const img = getThumbUrl(item);

        return `
          <div style="
            padding:10px 0;
            border-bottom:1px solid #e3edf8;
            display:flex;
            gap:12px;
            align-items:flex-start;
          ">
            <div style="
              width:50px;
              height:50px;
              border-radius:10px;
              overflow:hidden;
              border:1px solid #dbe7f5;
              background:#f6f9ff;
              flex:0 0 50px;
            ">
              ${img ? `
                <img src="${img}" alt=""
                     style="width:100%;height:100%;object-fit:cover;display:block;" />
              ` : `
                <div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;color:#9aa9bf;font-size:10px;font-weight:700;">
                  IMG
                </div>
              `}
            </div>

            <div style="flex:1;min-width:0;">
              <div style="
                font-size:14px;
                font-weight:600;
                color:#1f2d3d;
                line-height:1.4;
                word-break:break-word;
              ">
                ${item.product_title}
              </div>
              ${v ? `
                <div style="
                  font-size:12px;
                  color:#6b7c93;
                ">
                  ${v}
                </div>` : ''}
            </div>
          </div>
        `;
      }).join('');

      const html = `
        <div style="
          border:1px solid #dbe7f5;
          border-radius:14px;
          background:#ffffff;
          padding:16px;
        ">
          <div style="
            display:flex;
            align-items:center;
            justify-content:space-between;
            gap:12px;
            margin-bottom:12px;
          ">
            <div style="
              font-size:18px;
              font-weight:800;
              color:#25449c;
            ">
              Your Selected Stock Products
            </div>

            <div style="
              background:#eef5ff;
              color:#25449c;
              border:1px solid #dbe7f5;
              padding:6px 10px;
              border-radius:999px;
              font-size:12px;
              font-weight:700;
              white-space:nowrap;
            ">
              ${count} product${count === 1 ? '' : 's'}
            </div>
          </div>

          <div>
            ${itemsHtml}
          </div>

          <div style="
            margin-top:12px;
            font-size:12px;
            color:#6b7c93;
          ">
            To make changes, please update your cart.
          </div>
        </div>
      `;

      return { text, html };

    } catch (e) {
      console.error(TAG, 'Failed to build cart', e);
      return { text: '', html: '' };
    }
  }

  async function sendToPify() {
    const { text, html } = await buildCart();

    // IMPORTANT: must be STRING JSON (Pify uses JSON.parse)
    const msg = JSON.stringify({
      pifyform: {
        cart_list: text,
        cart_list_html: html
      }
    });

    let sent = false;

    ['form-iframe-4112', 'form-iframe-17422', 'form-iframe-18458'].forEach(id => {
      const iframe = document.getElementById(id);
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(msg, '*');
        sent = true;
      }
    });

    if (sent) console.log(TAG, 'Cart sent to Pify');
    else console.warn(TAG, 'Pify iframe not ready yet');
  }

  // Retry because iframe loads late
  document.addEventListener('DOMContentLoaded', () => {
    let tries = 10;
    const tick = () => {
      sendToPify();
      tries--;
      if (tries > 0) setTimeout(tick, 1000);
    };
    setTimeout(tick, 800);
  });
})();
